export default "__VITE_ASSET__GDs9k53c__$_?nuxt_component=async&nuxt_component_name=IUsdgNormalVerificationComplete__"